import { Route } from '@angular/router';
import { AuthGuard, LoginComponent, nonAuthGuard } from '@angular-monorepo/auth';
import { AuthenticatedLayoutComponent, NotFoundAuthenticatedComponent } from '@angular-monorepo/ui';
import { DashboardComponent } from '@angular-monorepo/dashboard';
import { MONITORING_ROUTES } from '@angular-monorepo/monitoring';
import { UsersComponent } from '@angular-monorepo/users';

export const appRoutes: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'dashboard',
  },
  {
    path: 'login',
    canActivate: [nonAuthGuard],
    component: LoginComponent,
  },
  {
    path: '',
    component: AuthenticatedLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard',
      },
      {
        path: 'dashboard',
        component: DashboardComponent,
      },
      ...MONITORING_ROUTES,
      {
        path: 'usuarios',
        component: UsersComponent,
      },
      {
        path: 'not-found',
        component: NotFoundAuthenticatedComponent,
      },
      {
        path: '**',
        redirectTo: 'not-found',
      },
    ],
  },
];
